<template>        
    <header class="logo__container">
        <img :src="cwa_logo_src" 
            class="logo__client" 
            alt="QPESUMS第二代"
        >
        <img src="/static/images/header/cwa-logo.png" 
            class="logo__cwa" 
            alt="中央氣象署"
        >
        <div v-if="show_custom && is_custom_logo_exist"
            class="logo__customization" 
        >
            <div class="logo__customization-divider" />
            <img
                :src="get_src(custom_logo)"
                class="logo__customization-img" 
                alt="客製化版本logo"
                contain
                @error="change_src()"
            >
        </div>
    </header>
</template>

<script>
    export default {
        name: 'Logo',

        props: {
            custom_logo: {
                type: String,
                required: true
            },

            show_custom: {
                type: Boolean,
                default: false,
                require: true
            },

            cwa_logo_src: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                is_custom_logo_exist: true
            };
        },

        methods: {
            get_src(image) {
                if (image == null) {
                    return ''
                } else {
                    return image
                }
            },

            change_src() {
                this.is_custom_logo_exist = false
            }
        },
    };
</script>

<style lang="scss" scoped>
@import '../../css/mixin.scss';
.logo {
    &__container {
        display: flex;
        align-items: center;
        margin: 8px;
        padding: 5px 10px;
        touch-action: none;

        &--map {
            position: absolute;
            border-radius: 20px;
            z-index: 2;
            background-image: linear-gradient(to right, rgba(35, 102, 247, .6) 0%, rgba(44, 253, 225, .6) 100%);
        }
    }

    &__client {
        max-width: 235px;

        @include mobile {
            max-width: 120px;
            max-height: 24px;
        }
    }

    &__cwa {
        margin-left: 7px;
        max-width: 38.4px;
        max-height: 24px;

        @include mobile {
            max-width: 26px;
            max-height: 16px;
        }
    }

    &__customization {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        margin: 0 1rem;

        @include mobile {
            margin: 0 0 0 1rem;
        }

        &::before {
            content: '';
            height: 50%;
        }

        &-img {
            height: 25px;

            @include mobile {
                height: 16px;
                vertical-align: bottom;
            }
        }

        &-divider {
            width: 2px;
            height: 18px;
            margin-right: 1em;
            border-left: 2px solid #fff;

            @include mobile {
                height: 16px;
                vertical-align: bottom;
            }
        }
    }
}
</style>
